var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker",class:{ 'picker--error': _vm.error },attrs:{"role":"radiogroup","aria-labelledby":`${_vm.id}_title`},on:{"mouseleave":function($event){return _vm.$emit('mouseleave', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }